import * as Actions from './customers.autocomplete.actions';

const initialState = {
  searchTerm: '',
  searchResults: [],
  searchPerformed: false,
};

export const customersNav = (state = initialState, action) => {
  const { searchResults, searchTerm } = action;

  switch (action.type) {
    case Actions.INITIATE_CUSTOMER_SEARCH:
      return {
        ...state,
        searchTerm,
      };
    case Actions.CUSTOMER_SEARCH_SUCCESS:
      return {
        ...state,
        searchResults,
      };
    case Actions.CUSTOMER_SEARCH_CLEAR_RESULTS:
      return initialState;
    default:
      return state;
  }
};

export { namespace } from './customers.autocomplete.reducer.metadata';
